import React from "react";

const ImagePreloader = (props) => {
  return (
    <React.Fragment>
      {props.Images.map((Item) => (
        <img alt="preloaded-image" hidden src={Item} />
      ))}
    </React.Fragment>
  );
};

export default ImagePreloader;
